import React from 'react';
import { request } from '../../../functions/apiRequestHelper';
import { gtmPush } from '../../../functions/gtm';
import { validate } from '../../../functions/validation';
import Button from '../../../audi-ui-components/Button';
import IconEmail from '../../../audi-ui-components/icons/ReceiveEmailNotification';
import IconDownload from '../../../audi-ui-components/icons/SystemDownload';
import IconReplay from '../../../audi-ui-components/icons/Replay';
import IconCaution from '../../../audi-ui-components/icons/Caution';
import Spinner from '../../../audi-ui-components/Spinner';
import Modal from '../../../audi-ui-components/Modal';
import TextField from '../../../audi-ui-components/TextField';
import { PATH_REQUEST_TESTDRIVE } from '../../../constants';
import SummaryList from './SummaryList';
import EmailFormModal from './EmailFormModal';
import ApplyFormModal from './ApplyFormModal';
import { getPayload } from './helpers';

class StepSummary extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            showEmailModal: false,
            showApplyModal: false,
            applyUrl: null
        };
    }

    componentDidMount() {
        gtmPush("afsCalculator", "StageLoaded", "AfsCalSummary");
    }

    onClickDownload = () => {
        gtmPush("afsCalculator", "DownloadCalculation", "AfsCalSummary");
        const {variant, loantype} = this.props;
        this.setState({loading: true});
        let payload = getPayload(this.props);
        request(`${process.env.RAZZLE_API_HOST}/1/afs/pdf`, {
            method: "POST",
            body: JSON.stringify(payload)
        }).then(
            response => response.blob()
        ).then(blob => {
            let url = window.URL.createObjectURL(blob);
            let a = document.createElement('a');
            a.style.display = 'none';
            a.href = url;
            a.download = `AFS_${variant.label.replace(" ", "-")}_${loantype}_repayments.pdf`;
            document.body.appendChild(a);
            a.click();
            window.URL.revokeObjectURL(url);
            this.setState({loading: false});
        }).catch(error => {
            console.error(error);
            this.setState({loading: false});
        });
    }

    onClickEmail = () => {
        gtmPush("afsCalculator", "EmailCalculation", "AfsCalSummary");
        this.setState({showEmailModal: true});
    }

    render() {
        const {variant, prices, responseSummary, responseError, calculating} = this.props;
        let confUrl = "https://www.audi.com.au";
        if (variant && variant.configuratorUrl) { confUrl = variant.configuratorUrl; }
        else if (variant && variant.url) { confUrl = variant.url; }
        if (confUrl.indexOf("http") !== 0) {
            let domain = "https://www.audi.com.au";
            if (confUrl.indexOf("/") !== 0) {
                domain = domain + "/";
            }
            confUrl = domain + confUrl;
        }
        return (
            <div className="position-relative">
                {(calculating || this.state.loading) && <div className="spinner-wrapper"><Spinner isContinuous /></div>}

                {variant && <p className="label mb-3">Finance repayments for your {variant.label}:</p>}
                <div className="row">
                    <div className="col-12 col-small-6 col-medium-7">
                        {prices && <img src={prices.ImagePath} alt="vehicle image" />}
                    </div>
                    <div className="col-12 col-small-6 col-medium-5">
                        {responseError && <p className="aui-color-text-red aui-headline-5 my-5"><IconCaution small /> An error has occured.</p>}

                        {responseSummary.DriveawayPrice && <div className="row price__row">
                            <div className="col">
                                <p className="label">{responseSummary.DriveawayPrice.label}:</p>
                            </div>
                            <div className="col-auto text-right">
                                <p className="price__amount">${responseSummary.DriveawayPrice.value}</p>
                            </div>
                        </div>}

                        {!responseError && <hr className="my-5" />}

                        <SummaryList responseSummary={responseSummary} />

                        {!responseError && <hr className="my-5" />}

                        {(responseSummary && responseSummary.DriveawayPrice) && <>
                            <div className="summary-ctas mb-3">
                                <Button variant="primary" onClick={()=>{
                                    gtmPush("afsCalculator", "OnlineApplicationMainCTA", "AfsCalSummary");
                                    this.setState({showApplyModal: true});
                                }} theme={this.props.theme === "dark" ? "light" : null}>Complete an online finance enquiry</Button>
                                
                                <Button variant="secondary" onClick={() => {
                                    gtmPush("afsCalculator", "TailorRepayments", "AfsCalSummary");
                                    this.props.onClickEdit();
                                }} theme={this.props.theme === "dark" ? "light" : null}>Tailor your repayments</Button>
                            </div>
                            <p>
                                <Button icon={<IconDownload small />} onClick={this.onClickDownload} theme={this.props.theme === "dark" ? "light" : null}>Download repayment calculation</Button>
                            </p>
                            <p>
                                <Button icon={<IconEmail small />} onClick={this.onClickEmail} theme={this.props.theme === "dark" ? "light" : null}>Email repayment calculation</Button>
                            </p>
                            <p>
                                <Button icon={<IconReplay small />} onClick={() => {
                                    gtmPush("afsCalculator", "Restart", "AfsCalSummary");
                                    this.props.onClickReset();
                                }} theme={this.props.theme === "dark" ? "light" : null}>Recalculate new vehicle</Button>
                            </p>
                        </>}
                    </div>
                </div>

                <div className="mt-5">
                    <Button variant="text" className="back" onClick={this.props.onClickBack} theme={this.props.theme === "dark" ? "light" : null}>Back</Button>
                </div>

                <hr className="my-5" />
                <div className="row">
                    <div className="col-12 col-medium-7">
                        <p className="label mb-2">Confirm how you would like to move forward with your Audi by choosing one of the options below.</p>
                        <p className="mb-3">Either request a customised quote, book a test drive at a dealership close to you, or complete an online finance enquiry now.</p>
                    </div>
                </div>
                <div className="row">
                    {confUrl && <div className="col-6 col-small-4">
                        <a href={confUrl} target="_blank" onClick={() => { gtmPush("afsCalculator", "RequestCustomisedQuote", "AfsCalSummary"); }} className={`aui-button aui-button--text text-left img-button${this.props.theme === "dark" ? " dark-mode" : ""}`}>
                            <span className="img" style={{backgroundImage: `url("${process.env.PUBLIC_PATH}img/afsimg3.jpg")`}} />
                            <span className="aui-button__text">Request a customised quote</span>
                        </a>
                    </div>}
                    {(variant && variant.value) && <div className="col-6 col-small-4">
                        <a href={`${process.env.RAZZLE_APP_HOST}${PATH_REQUEST_TESTDRIVE}?v=${variant.value}`} target="_blank" onClick={() => { gtmPush("afsCalculator", "BookATestDrive", "AfsCalSummary"); }} className={`aui-button aui-button--text text-left img-button${this.props.theme === "dark" ? " dark-mode" : ""}`}>
                            <span className="img" style={{backgroundImage: `url("${process.env.PUBLIC_PATH}img/afsimg2.jpg")`}} />
                            <span className="aui-button__text">Book a test drive</span>
                        </a>
                    </div>}
                    {(responseSummary && responseSummary.DriveawayPrice) && <div className="col-6 col-small-4">
                        <button onClick={()=>{
                            gtmPush("afsCalculator", "OnlineApplication", "AfsCalSummary");
                            this.setState({showApplyModal: true});
                        }} className={`aui-button aui-button--text text-left img-button${this.props.theme === "dark" ? " dark-mode" : ""}`}>
                            <span className="img" style={{backgroundImage: `url("${process.env.PUBLIC_PATH}img/afsimg1.jpg")`}} />
                            <span className="aui-button__text">Complete an online finance enquiry</span>
                        </button>
                    </div>}
                </div>

                <EmailFormModal
                  isActive={this.state.showEmailModal}
                  close={() => { this.setState({showEmailModal: false}); }}
                  payload={getPayload(this.props)}
                  theme={this.props.theme}
                />
                
                <ApplyFormModal
                  {...this.props}
                  isActive={this.state.showApplyModal}
                  close={() => { this.setState({showApplyModal: false}); }}
                  theme={this.props.theme}
                />

                <Modal isActive={Boolean(this.state.applyUrl)} variant="layer" closeButton close={() => { this.setState({applyUrl: null}); }}>
                    <p className="py-5">We couldn't automatically redirect you. Please <a href={this.state.applyUrl} target="_blank" className="aui-textlink">click here</a> for your online finance application.</p>
                </Modal>
            </div>
        );
    }
}

export default StepSummary;
